module.exports = __webpack_public_path__ + "assets/img/PrizePool_btn.23d3ae1e.png";